const styles = {
  arrow: {
    '&.slick-next, &.slick-prev': {
      width: '22px',
      height: '22px',
    },
  },
  previous: {
    '&.slick-next, &.slick-prev': {
      transform: 'translate(0, -50%) rotate(180deg)',
    },
  },
};

export default styles;
